import get from 'lodash/get';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { GroupWithTicketTypeIds } from '../../../../common/types';
import type { ImmutableState } from '../../types';

const setGroupsByTicketTypes =
	(groupRelations: GroupWithTicketTypeIds[]) =>
	({ getState, setState }: StoreActionApi<ImmutableState>) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		let groupsByTicketType: Record<string, any> = {};

		groupRelations.forEach(({ id: groupId, ticketTypes }: GroupWithTicketTypeIds) => {
			groupsByTicketType = ticketTypes.reduce(
				(acc, ticketTypeId) => ({
					// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
					...acc,
					[ticketTypeId]: [...get(acc, ticketTypeId, []), groupId],
				}),
				groupsByTicketType,
			);
		});

		setState({
			...getState(),
			groupsByTicketType,
		});
	};

export default setGroupsByTicketTypes;
